export const nl = {
  title: 'Intacte boslandschappen',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Functie',
      value:
        "Identificeert 's werelds laatst overgebleven niet-gefragmenteerde boslandschappen, groot genoeg om alle inheemse biodiversiteit te behouden en geen tekenen van menselijke verandering te vertonen vanaf het jaar 2020. Deze laag toont ook de afname in de omvang van intacte boslandschappen tussen 2000 en 2020.",
    },
    {
      label: 'Resolutie',
      value: 'Ongeveer 1:1.000.000',
    },
    {
      label: 'Geografische dekking',
      value: 'Globaal',
    },
    {
      label: 'Bron',
      value:
        'Potapov, P., MC Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer en E. Esipova. 2017. "De laatste grenzen van de wildernis: het verlies van intacte boslandschappen volgen van 2000 tot 2013." Wetenschapsvooruitgang 3: e1600821.',
    },
    {
      label: 'Frequentie',
      value: 2020,
    },
    {
      label: 'Datum van inhoud',
      value:
        "De IFL-wereldkaart is gemaakt door middel van visuele interpretatie van Landsat-afbeeldingen door experts. De kaart kan onnauwkeurigheden bevatten als gevolg van beperkingen in de ruimtelijke resolutie van de beelden en het gebrek aan aanvullende informatie over lokale praktijken op het gebied van landgebruik in sommige regio's. Bovendien gaat de methodologie ervan uit dat branden in de nabijheid van wegen of andere infrastructuur mogelijk door mensen zijn veroorzaakt en daarom een ​​vorm van antropogene verstoring vormen. Deze aanname zou kunnen resulteren in een onderschatting van de IFL-omvang in het boreale bioom.",
    },
    {
      label: 'Waarschuwingen',
      value: 'CC BY 4.0',
    },
    {
      label: 'Licentie',
      value:
        'De dataset Intact Forest Landscapes (IFL) identificeert ononderbroken uitgestrekte natuurlijke ecosystemen binnen de boszone die geen tekenen van significante menselijke activiteit vertonen en groot genoeg zijn om alle inheemse biodiversiteit, inclusief levensvatbare populaties van uiteenlopende soorten, in stand te kunnen houden. Om IFL-gebieden in kaart te brengen, werd een reeks criteria ontwikkeld en ontworpen om wereldwijd toepasbaar en gemakkelijk repliceerbaar te zijn, waarbij de laatste zowel herhaalde beoordelingen in de loop van de tijd als verificatie mogelijk maakte. IFL-gebieden werden gedefinieerd als niet-gefragmenteerde landschappen, minimaal 50.000 hectare groot en met een minimale breedte van 10 kilometer. Deze werden vervolgens in kaart gebracht op basis van Landsat-satellietbeelden voor het jaar 2000.',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Greenpeace, Universiteit van Maryland, World Resources Institute en Transparent World. “Intacte boslandschappen. 2000/2013/2016/2020” Toegankelijk via Global Forest Watch op 31/01/2025. www.globalforestwatch.org',
  },
  citation: {
    label: 'Aanhaling',
    value: 'Sağlam Meşə Mənzərələri',
  },
};
